var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.9998 12.6873C21.9998 18.2113 17.5228 22.6873 11.9998 22.6873C6.47676 22.6873 1.99976 18.2113 1.99976 12.6873C1.99976 7.16526 6.47676 2.68726 11.9998 2.68726C17.5228 2.68726 21.9998 7.16526 21.9998 12.6873Z",
    fill: "#0B7077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5734 16.5018C15.4424 16.5018 15.3104 16.4678 15.1894 16.3968L11.2634 14.0548C11.0374 13.9188 10.8984 13.6738 10.8984 13.4098V8.36279C10.8984 7.94879 11.2344 7.61279 11.6484 7.61279C12.0624 7.61279 12.3984 7.94879 12.3984 8.36279V12.9838L15.9584 15.1068C16.3134 15.3198 16.4304 15.7798 16.2184 16.1358C16.0774 16.3708 15.8284 16.5018 15.5734 16.5018Z",
    fill: "#0B7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircle);
export default __webpack_public_path__ + "static/media/Time Circle.5165fd8fd89ef467e0ccff4f612620e5.svg";
export { ForwardRef as ReactComponent };